/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Password_Too_ShortInputs */

const fr_error_password_too_short = /** @type {(inputs: Error_Password_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez au moins 15 caractères. Une courte phrase convient très bien.`)
};

const en_error_password_too_short = /** @type {(inputs: Error_Password_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use at least 15 characters. A short sentence works well.`)
};

/**
* | output |
* | --- |
* | "Use at least 15 characters. A short sentence works well." |
*
* @param {Error_Password_Too_ShortInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_password_too_short = /** @type {((inputs?: Error_Password_Too_ShortInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Password_Too_ShortInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_password_too_short(inputs)
	return fr_error_password_too_short(inputs)
});